var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#D4D4D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 20.4167H23.1608L20.9554 22.6221C20.9156 22.6606 20.8839 22.7065 20.862 22.7574C20.8402 22.8082 20.8287 22.8629 20.8282 22.9182C20.8278 22.9735 20.8383 23.0284 20.8592 23.0796C20.8802 23.1308 20.9111 23.1773 20.9503 23.2165C20.9894 23.2556 21.0359 23.2865 21.0871 23.3075C21.1383 23.3284 21.1932 23.339 21.2485 23.3385C21.3038 23.338 21.3585 23.3265 21.4093 23.3047C21.4602 23.2828 21.5062 23.2511 21.5446 23.2113L24.4613 20.2946C24.5394 20.2165 24.5833 20.1105 24.5833 20C24.5833 19.8896 24.5394 19.7836 24.4613 19.7055L21.5446 16.7888C21.466 16.7129 21.3608 16.6709 21.2515 16.6718C21.1423 16.6728 21.0378 16.7166 20.9605 16.7939C20.8832 16.8711 20.8394 16.9756 20.8385 17.0849C20.8375 17.1941 20.8795 17.2994 20.9554 17.378L23.1608 19.5834H15.8333C15.7228 19.5834 15.6169 19.6273 15.5387 19.7054C15.4606 19.7836 15.4167 19.8895 15.4167 20C15.4167 20.1106 15.4606 20.2165 15.5387 20.2947C15.6169 20.3728 15.7228 20.4167 15.8333 20.4167Z",
    fill: "#FF6000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrow);
export default __webpack_public_path__ + "static/media/circleArrow.3195014170a039b9d63dfa3f320dd97b.svg";
export { ForwardRef as ReactComponent };